import { render, staticRenderFns } from "./ManageSharing.vue?vue&type=template&id=f3f40580&scoped=true&lang=pug&"
import script from "./ManageSharing.vue?vue&type=script&lang=js&"
export * from "./ManageSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f40580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
